"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.size = void 0;
const types_1 = require("../../types");
const { SizeEnum } = types_1.Vehicle;
exports.size = [
    {
        id: SizeEnum.Large,
        name: 'Large',
    },
    {
        id: SizeEnum.MidSize,
        name: 'Mid-Size',
    },
    {
        id: SizeEnum.Compact,
        name: 'Compact',
    },
    {
        id: SizeEnum.Subcompact,
        name: 'Subcompact',
    },
];
